import { Model } from './_model';
import defaultIcon from '../assets/www.svg';

export default class Session extends Model {
  get defaults() {
    return {
      securityId: '',
      securityIssuer: '',
      securityLogo: '',
      currency: '',
      minimumIncrements: 0,
      minimumDenomination: 0,
      sessionStartTime: '',
      sessionTimeDelta: '',
      sessionTimeRemaining: '',
      securityName: '',
      securityOfferCloseDate: '',
      securityOfferDate: '',
      securityAgentDisplayName: ''
    }
  }

  get securityLogoSrc() {
    if(this.securityLogo == null){
      return defaultIcon;
    }
    return this.securityLogo;
  }
}





